import React, { Component } from 'react';
import axios from 'axios';
import randomColor from 'randomcolor'
import InfiniteScroll from 'react-infinite-scroller';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

const img = {
  width: '100%',
  height: 'auto',
  maxWidth: '100%',
}

const label_style = {
  fontWeight:700, 
  fontFamily:"Inconsolata"
}

class ImageRow extends Component {

  colorLabels = (label_list) => {
    let label_color_map = {};
    label_list = label_list.map((label)=> {
        let rand_color = randomColor({luminosity: 'dark', format: 'rgb'});
        label_color_map[label] = rand_color;
        return (<p><span style={{color: rand_color, ...label_style}}>{label}</span></p>);
      }
    )
    return [label_color_map, label_list];
  }

  colorCaptions = (captions, label_list) => {
    let new_captions = captions.map((caption)=> {
      String.prototype.replaceAll = function(search, replacement) {
        var target = this;
        return target.replace(new RegExp(search, 'i'), replacement);
      };

      let new_caption = caption;
      
      Object.entries(label_list).forEach(
        ([key, value]) => {
          new_caption = new_caption.replaceAll(key, `<span style="color:${value}; font-weight:700; font-family:Inconsolata">${key.toLowerCase()}</span>`);
        }
      );
      return new_caption;
    });

    return new_captions;
  }

  render() {
    const label_list = this.props.annotations.map((ann) => ann.label)
    let unique_label_list = [...new Set(label_list)];
    var label_column;

    [unique_label_list, label_column] = this.colorLabels(unique_label_list);
    
    let color_captions = this.colorCaptions(this.props.captions, unique_label_list);

    const caption_list = color_captions.map((caption) => <p dangerouslySetInnerHTML={{__html: caption}} />)
    
    // console.log(unique_label_list)
    // unique_label_list = Object.entries(unique_label_list).forEach(
    //   ([key, value]) => <p><span style={{"color": value}}>{key}</span></p>
    // );

    // unique_label_list = unique_label_list.map((label)=> <p><span>{label}</span></p>)
    const domain_map = {
      'in-domain': 'in-domain',
      'near-domain': 'near-domain',
      'out-domain': 'out-of-domain'
    };
    
    return (
      <Grid container spacing={4}>
        <Grid item xs={4}><img src={this.props.url} style={img} alt={this.props.url}></img></Grid>
        <Grid item xs={4}>{caption_list}</Grid>
        <Grid item xs={2}>{label_column}</Grid>
        <Grid item xs={2}><p style={label_style}>{domain_map[this.props.domain]}</p></Grid>
        <Divider light />
      </Grid>
    );
  }
}

class Explore extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      page: 0,
      table: [],
      hasMoreItems: true
    };

    this.pageLength = 10;
  }

  shuffle = (a) => {
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}
 
  fetchData = () => {
    axios.get("https://s3.amazonaws.com/nocaps/nocaps_explore_val_data.json")
    .then((response)  => {
      this.setState({data: this.shuffle(response.data)});
      // this.renderRows();
    })
    .catch((error) => {
      console.log(error);
    });
  }
  
  renderRows = () => {
    let table = this.state.table;
    let page = this.state.page;

    if (this.state.data) {
      // Outer loop to create parent
      const final_idx = Math.min((page + 1) * this.pageLength, this.state.data.length);
      for (let i = page * this.pageLength; i < final_idx ; i++) {
        var image_data = this.state.data[i];
        table.push(image_data);
      }
      
      this.setState({
        table: table,
        page: page + 1,
        hasMoreItems: final_idx < this.state.data.length ? true : false
      });
    }
  }

  componentDidMount() {
    this.fetchData();
  }

  render() {
    const loader = <div className="loader">Loading ...</div>;
    var items = [];
    this.state.table.map((image_data, i) => {
        items.push(
          <ImageRow url={image_data.url} captions={image_data.captions} annotations={image_data.annotations} domain={image_data.domain}/>
        );
    });

    return (
      <Container fixed maxWidth="lg">
        <Grid container spacing={4} style={{paddingTop: "10px", fontWeight: 600, fontSize:20}}>
          <Grid item xs={4}>Image</Grid>
          <Grid item xs={4}>Reference Captions</Grid>
          <Grid item xs={2}>Object Classes</Grid>
          <Grid item xs={2}>Domain</Grid>
          <Divider/>
        </Grid>
        <InfiniteScroll
          pageStart={0}
          loadMore={this.renderRows}
          hasMore={this.state.hasMoreItems}
          loader={loader}>
            {items}
        </InfiniteScroll>   
      </Container>
         
    );
  }
}

export default Explore;
